module.exports = __webpack_public_path__ + "assets/img/关于我们banner02.5ca3bca5.jpg";